<div class="dialog-top">
  <h2 mat-dialog-title>{{ 'Option edit' | translate }}</h2>
  <button mat-icon-button mat-dialog-close tabindex="-1" (click)="onCancel()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content>

  <div class="d-flex gap-2 h-100">
    <div class="cdc-form-field w-50"
      [ngClass]="{
      'error': !isJsonValid,
      'actif': option.value && isJsonValid
    }">
      <div #jsonLabel class="cdc-label d-flex flex-row justify-content-between">{{ 'Value' | translate }} <mat-slide-toggle [(ngModel)]="isJson" (change)="validateJson()" [matTooltip]="'JSON' | translate"></mat-slide-toggle></div>
      <textarea #autoResizeTextarea matInput [(ngModel)]="option.value" (ngModelChange)="validateJson()" (focusout)="beautifyJSON()"></textarea>
    </div>

    <div class="cdc-form-field actif w-50">
      <div class="cdc-label">{{ 'Display' | translate }}</div>
      <angular-editor #editorTextArea [config]="config" [(ngModel)]="editorText" (ngModelChange)="onEditorChange($event)"></angular-editor>
    </div>
  </div>

</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">{{ 'Cancel' | translate }}</button>
  <button mat-button color="primary" (click)="onConfirm()" [disabled]="!isJsonValid">{{ 'Confirm' | translate }}</button>
</mat-dialog-actions>
